import { render, staticRenderFns } from "./TamaishikiLogin.vue?vue&type=template&id=74f74299&scoped=true&"
import script from "./TamaishikiLogin.vue?vue&type=script&lang=js&"
export * from "./TamaishikiLogin.vue?vue&type=script&lang=js&"
import style0 from "./TamaishikiLogin.vue?vue&type=style&index=0&id=74f74299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f74299",
  null
  
)

export default component.exports